import { marked } from "marked";

export const convertMarkdownToHtml = async (markdown: string): Promise<string> => {
  // Configure marked to handle line breaks
  marked.setOptions({
    breaks: true,
    gfm: true
  });
  
  // Replace single newlines with <br> tags before processing markdown
  const processedMarkdown = markdown.replace(/(?<!\n)\n(?!\n)/g, '  \n');
  
  return marked(processedMarkdown);
};